import { FilterdColumns } from '@oscar/table';
import { APPLICABLE_SERVICE } from 'common/constants';
import React from 'react';
import './style.scss';

const { OptionGroup } = FilterdColumns;

function FilterApplicableService(props: any) {
  return (
    <OptionGroup
      {...props}
      data={Object.values(APPLICABLE_SERVICE).map(item => ({
        value: item.VALUE,
        label: item.TEXT,
      }))}
    />
  );
}

export default FilterApplicableService;
